import { AdaBindMethodPipe, AdaBytesToSizePipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { DefaultConfigFactoryPipe } from '@adaptiva/data-service';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { DrawerComponent } from '@adaptiva/widgets/drawer';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { MemoryPipelineComponentModule } from '@adaptiva/widgets/memory-pipeline';
import { ObjectListModule } from '@adaptiva/widgets/object-list';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MemoryPipelinePageComponent } from './memory-pipeline-page.component';

const routes: Routes = [
	{
		path: '',
		title: 'Memory Pipeline',
		component: MemoryPipelinePageComponent,
	},
];

@NgModule({
	imports: [
		AdaBindMethodPipe,
		AdaBytesToSizePipe,
		CommonModule,
		ContainerComponentModule,
		DefaultConfigFactoryPipe,
		DrawerComponent,
		LabelComponentModule,
		MemoryPipelineComponentModule,
		ObjectListModule,
		OverlayComponentModule,
		TemplateMarkerDirectiveModule,
		TextComponentModule,
		RouterModule.forChild(routes),
		DynamicComponentLoaderModule.forChild(MemoryPipelinePageComponent),
	],
	declarations: [
		MemoryPipelinePageComponent
	],
	exports: [MemoryPipelinePageComponent]
})
export class MemoryPipelinePageComponentModule { }
